import { Dispatch, FC, Fragment, useEffect, useState } from "react";
import {
  Box, FormControl, Grid, InputLabel, Select, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, styled, tableCellClasses, Backdrop, CircularProgress
} from "@mui/material";
import { useStyles } from "../styles";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { DataRef } from "../../../types/DataRef";
import { ActionType, AlertType } from "../../../types/AlertType";
import { AxiosInstance } from "axios";
import CheckAttr from "../../../utils/CheckAttr";
import {
  DataSaisieManager,
  IPeriodeCloture,
  PeriodSaisi,
} from "../../content/production/SaisieAgent";
import AddSaisieAgentRowForm from "./AddSaisieAgentRowForm";

import { PROFIL_COUNTRY_MANAGER, PROFIL_MANAGER, PROFIL_ROA, articlesSansActes } from '../../../constants/Constants';
import { ConnectedUser } from '../../../utils/utils';

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#fff",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#080d24",
    color: theme.palette.common.white,
    fontSize: 11,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
    fontWeight: "bold",
  },
}));

export interface DataPivotPaysBu {
  id: number;
  business_unit: DataRef;
}

export interface DataArticle {
  id: number;
  libelle: string;
  code_article: {
    id: number;
    libelle: string;
  };
  devise: {
    id: number;
    monnaie: string;
    symbole: string;
    code_iso: string;
  };
  cout: {
    coutactivite: string;
    coutformation: string;
  };
  tarification: {
    tarifheure: string;
    tarifacte: string;
  };
  saisie_manager: {
    id: number;
    date_saisie: string;
    heuresprod: string;
    heures_ca: string;
    actes: string;
    dmt: string;
    manual: number;
  }[];
  EstFormation: boolean;
}
export interface Heure {
  article: number;
  caHeures: string;
  caActes: string;
  tarifHeures: number;
  tarifActes: number;
  chiffreAffaire?: number;
  coutHeures: string;
  coutParHeures: number;
  cout?: number;
  dmt: string;
  manual?: number;
}

interface SUMMENSUEL {
  sum_tarif_heure: string;
  sum_tarif_acte: string;
  sum_heure_ca: string;
  actes: string;
  heures_prod: string;
  sum_cout_per_hours: string;
  sum_CA: string;
  sum_cout: string;
}

interface HeureToSave {
  pays?: number;
  client?: number;
  operation?: number;
  date_saisie?: Date;
  saisieAgents: Heure[];
}

interface SaisieAgentFormProps {
  saisieAgent?: DataSaisieManager;
  periodSaisi: PeriodSaisi;
  dataPaysInAssociations: DataRef[];
  http: AxiosInstance;
  onClose: () => void;
  reloadList: () => void;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
  allPeriodeClotured: IPeriodeCloture[]
}

const initialsummensuel: SUMMENSUEL = {
  sum_tarif_heure: "",
  sum_tarif_acte: "",
  sum_heure_ca: "",
  actes: "",
  heures_prod: "",
  sum_cout_per_hours: "",
  sum_CA: "",
  sum_cout: "",
};

const resetCoutToSave: HeureToSave = {
  pays: undefined,
  operation: undefined,
  client: undefined,
  date_saisie: undefined,
  saisieAgents: [],
};

const AddSaisieAgentForm: FC<SaisieAgentFormProps> = ({
  dataPaysInAssociations,
  periodSaisi,
  http,
  onClose,
  reloadList,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  allPeriodeClotured
}) => {
  const classes = useStyles();

  const [reloadData, setReloadData] = useState<boolean>(false);
  const [isClickSave, setIsClickSave] = useState<boolean>(false);

  const [dataClients, setDataClients] = useState<DataRef[]>([]);
  const [dataOperations, setDataOperations] = useState<DataRef[]>([]);
  const [dataArticles, setDataArticles] = useState<DataArticle[]>([]);
  const [dataSumMensuel, setDataSumMensuel] = useState<SUMMENSUEL>(initialsummensuel);
  const [saisieManagerToSave, setSaisieManagerToSave] = useState<HeureToSave>(resetCoutToSave);
  const [firstSumCAForThisDate, setFirstSumCAForThisDate] = useState<number>(0);
  const [firstSumCoutForThisDate, setFirstSumCoutForThisDate] = useState<number>(0);

  // const [sumDefaultCaHeures, setSumDefaultCaHeures] = useState<number>(0);
  // const [sumDefaultCaActes, setSumDefaultCaActes] = useState<number>(0);
  // const [sumDefaultTarifHeures, setSumDefaultTarifHeures] = useState<number>(0);
  // const [sumDefaultTarifActes, setSumDefaultTarifActes] = useState<number>(0);
  // const [sumDefaultChiffreAffaire, setSumDefaultChiffreAffaire] = useState<number>(0);
  // const [sumDefaultCoutHeures, setSumDefaultCoutHeures] = useState<number>(0);
  // const [sumDefaultCoutParHeures, setSumDefaultCoutParHeures] = useState<number>(0);
  // const [sumDefaultCout, setSumDefaultCout] = useState<number>(0);
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    if (saisieManagerToSave?.pays) {
      // Récupère les clients du pays sélectionné
      http
        .get(`client/get-clients-via-pays/${saisieManagerToSave?.pays}`)
        .then((res) => {
          Array.isArray(res.data) && setDataClients(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setSaisieManagerToSave({
        ...saisieManagerToSave,
        client: undefined,
        operation: undefined,
        saisieAgents: [],
      });
      setDataClients([]);
      setDataOperations([]);
    }
  }, [saisieManagerToSave?.pays]);

  useEffect(() => {
    if (saisieManagerToSave?.client) {
      // Récupère les opérations du client sélectionné et pays sélectionné
      //http.get(`operation/get-operations/via-client/${saisieManagerToSave?.client}`)
      http
        .get(
          `operation/get-operations/via-pays-client/${saisieManagerToSave?.pays}/${saisieManagerToSave?.client}`
        )
        .then((res) => {
          Array.isArray(res.data) && setDataOperations(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setSaisieManagerToSave({
        ...saisieManagerToSave,
        operation: undefined,
        saisieAgents: [],
      });
      setDataOperations([]);
    }
  }, [saisieManagerToSave?.client, saisieManagerToSave?.pays]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    // teste Date Cloture Si ADMIN
    if (name === 'date_saisie' && ![PROFIL_MANAGER, PROFIL_COUNTRY_MANAGER, PROFIL_ROA].includes(user?.profils?.libelle)) {

      let TesteSiValueInDateDisable = false;
      allPeriodeClotured.map((dateTmp) => {
        // Si Le Value est Inclu Dans L'un des Periode Cloture
        if (value >= dateTmp.date_debut && value <= dateTmp.date_fin) {
          // Disable
          setAlerteMessage(
            `le ${dateTmp.date_debut} a ${dateTmp.date_fin} est Deja Cloturé`
          );
          setAlertType("warning");
          setOpenSnack(true);

          TesteSiValueInDateDisable = true;
        }
      })

      if (!TesteSiValueInDateDisable) {
        // Si il n'est pas Inclue Dans Tout les Periode Clotures
        setSaisieManagerToSave({
          ...saisieManagerToSave,
          [name]: value,
        });
      } else {
        setSaisieManagerToSave({
          ...saisieManagerToSave,
          [name]: '',
        });
      }

    } else {
      setSaisieManagerToSave({
        ...saisieManagerToSave,
        [name]: value,
      });
    }


    if (name === 'client') {
      setDataArticles([]);
      console.log("Client");
    }
  };

  const defaultSumFromBack = (operations: DataArticle[]) => {
    let tmpSumDefaultCaHeures = 0;
    let tmpSumDefaultCaActes = 0;
    let tmpSumDefaultTarifHeures = 0;
    let tmpSumDefaultTarifActes = 0;
    let tmpSumDefaultChiffreAffaire = 0;
    let tmpSumDefaultCoutHeures = 0;
    let tmpSumDefaultCoutParHeures = 0;
    let tmpSumDefaultCout = 0;

    for (const operation of operations) {
      let tmpCA = 0;
      let tmpCAActe = 0;
      let tmpTarifHeure = 0;
      let tmpTarifActe = 0;
      let tmpCAHeure = 0;
      let tmpCoutParHeure = 0;
      let tmpHeureProd = 0;
      if (operation?.saisie_manager?.length > 0) {
        const heure = operation?.saisie_manager[0];
        if (heure.heures_ca) {
          tmpCAHeure = Number(heure.heures_ca);
        }

        if (heure.actes) {
          tmpCAActe = Number(heure?.actes);
        }

        if (heure?.heuresprod) {
          tmpHeureProd = Number(heure?.heuresprod);
        }
      }

      if (operation?.tarification) {
        const tarif = operation?.tarification;

        if (tarif?.tarifheure) {
          tmpTarifHeure = Number(tarif?.tarifheure);
        }

        if (tarif?.tarifacte) {
          tmpTarifActe = Number(tarif?.tarifacte);
        }
      }

      if (tmpTarifHeure && tmpTarifActe) {
        let ca_heure = 0;
        if (tmpCAHeure && tmpTarifHeure) {
          ca_heure = tmpCAHeure * tmpTarifHeure;
        }

        let ca_actes = 0;
        if (tmpCAActe && tmpTarifActe) {
          ca_actes = tmpCAActe * tmpTarifActe;
        }

        tmpCA = ca_heure + ca_actes;
      } else {
        if (tmpTarifHeure && tmpCAHeure) {
          tmpCA = tmpCAHeure * tmpTarifHeure;
        }

        if (tmpTarifActe && tmpCAActe) {
          tmpCA = tmpCAActe * tmpTarifActe;
        }
      }

      if (operation?.cout) {
        const cout = operation?.cout;

        if (operation?.EstFormation) {
          tmpCoutParHeure = Number(cout?.coutformation);
        } else {
          tmpCoutParHeure = Number(cout?.coutactivite);
        }
      }

      tmpSumDefaultCaHeures += tmpCAHeure;
      tmpSumDefaultCaActes += tmpCAActe;
      tmpSumDefaultTarifHeures += tmpTarifHeure;
      tmpSumDefaultTarifActes += tmpTarifActe;
      tmpSumDefaultChiffreAffaire += tmpCA;
      tmpSumDefaultCoutHeures += tmpHeureProd;
      tmpSumDefaultCoutParHeures += tmpCoutParHeure;
      tmpSumDefaultCout += tmpHeureProd * tmpCoutParHeure;
    }

    // setSumDefaultCaHeures(tmpSumDefaultCaHeures);
    // setSumDefaultCaActes(tmpSumDefaultCaActes);
    // setSumDefaultTarifHeures(tmpSumDefaultTarifHeures);
    // setSumDefaultTarifActes(tmpSumDefaultTarifActes);
    // setSumDefaultChiffreAffaire(tmpSumDefaultChiffreAffaire);

    // setSumDefaultCoutHeures(tmpSumDefaultCoutHeures);
    // setSumDefaultCoutParHeures(tmpSumDefaultCoutParHeures);
    // setSumDefaultCout(tmpSumDefaultCout);
  };

  /**
   * @param filteredArticles
   * Calcul CA pour ce date selectionné
   */
  const calculAllCAForThisDate = (filteredArticles: DataArticle[]) => {
    let firstSumCA = 0;
    let firstSumCout = 0;
    for (const arti of filteredArticles) {
      for (const saisi of arti?.saisie_manager) {
        if (arti?.tarification?.tarifacte && saisi?.actes) {
          firstSumCA += (Number(arti?.tarification?.tarifacte) * Number(saisi?.actes));
        }

        if (arti?.tarification?.tarifheure && saisi?.heures_ca) {
          firstSumCA += (Number(arti?.tarification?.tarifheure) * Number(saisi?.heures_ca));
        }

        if (arti?.cout?.coutactivite && saisi?.heuresprod) {
          firstSumCout += (Number(arti?.cout?.coutactivite) * Number(saisi?.heuresprod))
        }
      }
    }

    setFirstSumCAForThisDate(firstSumCA);
    setFirstSumCoutForThisDate(firstSumCout);
  };

  useEffect(() => {
    if (
      CheckAttr(saisieManagerToSave?.date_saisie) &&
      CheckAttr(saisieManagerToSave?.pays) &&
      CheckAttr(saisieManagerToSave?.operation)
    ) {
      setDataArticles([]);
      setSaisieManagerToSave({ ...saisieManagerToSave, saisieAgents: [] });
      setLoader(true);
      // Récupère les opérations
      http.post("article/findby-pays-client-operation", {
        pays: saisieManagerToSave?.pays,
        operation: saisieManagerToSave?.operation,
        date_saisie: saisieManagerToSave?.date_saisie,
        mode: 'ADD',
        action: "saisieManager",
      }).then((res) => {
        const operations = res.data.operations as DataArticle[];

        const filteredOperations: DataArticle[] = [];
        for (const operation of operations) {
          let currOpetation: DataArticle;
          const heures = operation?.saisie_manager?.filter(
            (heure) =>
              heure?.date_saisie === String(saisieManagerToSave?.date_saisie)
          );
          currOpetation = { ...operation, saisie_manager: heures };
          filteredOperations.push(currOpetation);
        }

        if (Array.isArray(filteredOperations)) {
          /**
           * Calcul CA pour ce date selectionné
           */
          calculAllCAForThisDate(filteredOperations);
          setDataArticles(filteredOperations);
          defaultSumFromBack(filteredOperations);
          setDataSumMensuel(res.data.mensualSum);
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoader(false);
      });
    } else {
      setSaisieManagerToSave({
        ...saisieManagerToSave,
        saisieAgents: [],
      });
      setDataArticles([]);
    }
  }, [
    saisieManagerToSave?.pays,
    saisieManagerToSave?.operation,
    saisieManagerToSave?.date_saisie,
    reloadData
  ]);

  const handleChangeSaisieManager = (heure: Heure, action: ActionType) => {
    let defaultSaisieManagers = saisieManagerToSave.saisieAgents;

    if (action === "CREATE") {
      defaultSaisieManagers.push(heure);
    }

    if (action === "UPDATE") {
      const index = defaultSaisieManagers.findIndex(
        (c) => c.article === heure.article
      );
      defaultSaisieManagers[index] = heure;
    }

    setSaisieManagerToSave({
      ...saisieManagerToSave,
      saisieAgents: defaultSaisieManagers,
    });
  };

  const checkAuMoinsUneOperationSaisi = (): Heure[] => {
    const tabHeure = [];

    for (const heure of saisieManagerToSave?.saisieAgents) {
      if (heure.manual === undefined && CheckAttr(heure.coutHeures)) {
        // Heures de management non facturées : pas d'heures CA ni d'actes obligatoires (actes = 0)
        const libelle = dataArticles.find((article) => article.id === heure.article)?.libelle;

        if (articlesSansActes.includes(libelle as string)) {
          tabHeure.push({ ...heure, caActes: "0" });
        } else if (CheckAttr(heure.caHeures) || CheckAttr(heure.caActes)) {
          tabHeure.push(heure);
        }
      }
    }

    if (tabHeure.length === 0) {
      setAlerteMessage(
        "Merci de saisir des heures au moins un article parmi ceux qui n’ont pas encore de saisie SVP !"
      );
      setAlertType("warning");
      setOpenSnack(true);
    }

    return tabHeure;
  };

  const checkNewDateOperation = () => {
    let res = false;
    for (const articles of dataArticles) {
      if (
        articles?.saisie_manager &&
        articles?.saisie_manager[0]?.manual === undefined
      ) {
        res = true;
      }
    }

    if (!res) {
      setAlerteMessage(
        "Merci de saisir des heures pour une nouvelle date SVP !"
      );
      setAlertType("warning");
      setOpenSnack(true);
    }

    return res;
  };

  const handleSave = () => {
    if (checkNewDateOperation()) {
      const newHeures = checkAuMoinsUneOperationSaisi();

      if (newHeures.length > 0) {
        setIsClickSave(true);
        const datas: HeureToSave = {
          ...saisieManagerToSave,
          saisieAgents: newHeures,
        };

        http.post("saisie/manager/save", datas)
          .then(() => {
            setAlerteMessage("Enregistrement efféctuée !");
            setAlertType("success");
            setOpenSnack(true);
            // onClose();
            setReloadData(!reloadData);
            reloadList();
          })
          .catch((error) => {
            console.log(error);
            setAlertType("error");
            setOpenSnack(true);
          })
          .finally(() => {
            setIsClickSave(false);
          });
      }
    }
  };

  let showOperations = false;
  if (
    CheckAttr(saisieManagerToSave?.pays) &&
    CheckAttr(saisieManagerToSave?.client) &&
    CheckAttr(saisieManagerToSave?.operation) &&
    CheckAttr(saisieManagerToSave?.date_saisie) &&
    CheckAttr(dataArticles)
  ) {
    showOperations = true;
  }

  /* const sumCaHeures = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.caHeures) || 0),
    0
  );

  const sumCaActes = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.caActes) || 0),
    0
  );

  const sumTarifHeures = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.tarifHeures) || 0),
    0
  );

  const sumTarifActes = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.tarifActes) || 0),
    0
  ); */

  const sumChiffreAffaire = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.chiffreAffaire) || 0),
    0
  );

  /* const sumCoutHeures = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.coutHeures) || 0),
    0
  );

  const sumCoutParHeures = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.coutParHeures) || 0),
    0
  ); */

  const sumCout = saisieManagerToSave?.saisieAgents?.reduce(
    (acc, curr) => acc + (Number(curr.cout) || 0),
    0
  );

  // const sumMensuelCaHeures = parseFloat(dataSumMensuel?.sum_heure_ca) + sumCaHeures - sumDefaultCaHeures;
  // const sumMensuelCaActes = parseFloat(dataSumMensuel?.actes) + sumCaActes - sumDefaultCaActes;
  // const sumMensuelTarifHeures = parseFloat(dataSumMensuel?.sum_tarif_heure) + sumTarifHeures - sumDefaultTarifHeures;
  // const sumMensuelTarifActes = parseFloat(dataSumMensuel?.sum_tarif_acte) + sumTarifActes - sumDefaultTarifActes;
  const sumMensuelChiffreAffaire = (parseFloat(dataSumMensuel?.sum_CA) - firstSumCAForThisDate) + sumChiffreAffaire;


  // const sumMensuelCoutHeures = Number(dataSumMensuel?.heures_prod) + sumCoutHeures - sumDefaultCoutHeures;
  // const sumMensuelCoutParHeures = parseFloat(dataSumMensuel?.sum_cout_per_hours) + sumCoutParHeures - sumDefaultCoutParHeures;
  const sumMensuelCout = (parseFloat(dataSumMensuel?.sum_cout) - firstSumCoutForThisDate) + sumCout;

  const maxDate = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
  };

  /*
  * Si profil user connecter est manager, et si date now >= date verouillage, alors il faut verouiller les dates compris dans les périodes
  */
  const user = ConnectedUser();
  let minDate = periodSaisi?.date_debut;
  if ([PROFIL_MANAGER, PROFIL_COUNTRY_MANAGER, PROFIL_ROA].includes(user?.profils?.libelle)) {

    if (maxDate() >= periodSaisi?.date_verrouillage) {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = 1;

      minDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
    }
  }

  return (
    <Fragment>
      <Box className={classes.root} mb={3}>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="pays"
                color="warning"
                shrink={CheckAttr(saisieManagerToSave?.pays)}
              >
                Pays de production
              </InputLabel>
              <Select
                id="pays"
                native
                color="warning"
                value={saisieManagerToSave?.pays}
                onChange={handleChange}
                label="Pays de production"
                inputProps={{
                  name: "pays",
                }}
              >
                <option value=""></option>
                {dataPaysInAssociations.map((pays) => (
                  <option key={pays?.id} value={pays?.id}>
                    {pays?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={CheckAttr(saisieManagerToSave?.operation)}
              >
                Opération
              </InputLabel>
              <Select
                id="operation"
                native
                color="warning"
                value={saisieManagerToSave?.operation}
                onChange={handleChange}
                label="Opération"
                inputProps={{
                  name: "operation",
                }}
              >
                <option value=""></option>
                {dataOperations.map((operation) => (
                  <option key={operation?.id} value={operation?.id}>
                    {operation?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="client"
                color="warning"
                shrink={CheckAttr(saisieManagerToSave?.client)}
              >
                Client
              </InputLabel>
              <Select
                id="client"
                native
                color="warning"
                value={saisieManagerToSave?.client}
                onChange={handleChange}
                label="Client"
                inputProps={{
                  name: "client",
                }}
              >
                <option value=""></option>
                {dataClients.map((client) => (
                  <option key={client?.id} value={client?.id}>
                    {client?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
            <TextField
              name="date_saisie"
              label="Date saisie"
              type="date"
              color="warning"
              fullWidth
              value={saisieManagerToSave?.date_saisie}
              onKeyDown={(e) => e.preventDefault()}
              onChange={handleChange}
              // error={!CheckAttr(saisieManagerToSave?.date_saisie)}
              inputProps={{
                min: minDate,
                max: maxDate()
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {showOperations && (
        <>
          <TableContainer sx={{ mt: 4 }}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell />
                  <StyledTableCell />
                  <StyledTableCell colSpan={5}>Saisie CA</StyledTableCell>
                  <StyledTableCell />
                  <StyledTableCell colSpan={4}>Saisie Coût</StyledTableCell>
                  <StyledTableCell />
                  <StyledTableCell>Marges</StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell width={75}>Codes article</StyledTableCell>
                  <StyledTableCell width={150}>
                    Articles / Désignation
                  </StyledTableCell>
                  <StyledTableCell>Heures</StyledTableCell>
                  <StyledTableCell>Actes</StyledTableCell>
                  <StyledTableCell>PU Heure</StyledTableCell>
                  <StyledTableCell width={100}>PU Acte</StyledTableCell>
                  <StyledTableCell width={75}>CA HT</StyledTableCell>
                  <StyledTableCell />
                  <StyledTableCell>Heures</StyledTableCell>
                  <StyledTableCell>Coût/h</StyledTableCell>
                  <StyledTableCell>Coût</StyledTableCell>
                  <StyledTableCell>Devise</StyledTableCell>
                  <StyledTableCell colSpan={2} />
                </TableRow>
              </TableHead>
              <TableBody>
                {dataArticles.map((article) => (
                  <AddSaisieAgentRowForm
                    key={article.id}
                    article={article}
                    handleChangeSaisieManager={handleChangeSaisieManager}
                  />
                ))}
                <StyledTableRow>
                  <StyledTableCell />
                  <StyledTableCell>Total de la journée</StyledTableCell>
                  <StyledTableCell>{/* {sumCaHeures} */}</StyledTableCell>
                  <StyledTableCell>{/* {sumCaActes} */}</StyledTableCell>
                  <StyledTableCell>
                    {/* {parseFloat(String(sumTarifHeures))?.toFixed(2)} */}
                  </StyledTableCell>
                  <StyledTableCell>
                    {/* {parseFloat(String(sumTarifActes))?.toFixed(2)} */}
                  </StyledTableCell>
                  <StyledTableCell>
                    {parseFloat(String(sumChiffreAffaire))?.toFixed(2)}
                  </StyledTableCell>

                  <StyledTableCell />

                  <StyledTableCell>{/* {sumCoutHeures} */}</StyledTableCell>
                  <StyledTableCell>
                    {/* {parseFloat(String(sumCoutParHeures))?.toFixed(2)} */}
                  </StyledTableCell>
                  <StyledTableCell>
                    {parseFloat(String(sumCout))?.toFixed(2)}
                  </StyledTableCell>
                  <StyledTableCell />
                  <StyledTableCell />
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell />
                  <StyledTableCell>Total cumulé du mois</StyledTableCell>
                  <StyledTableCell>
                    {/* {sumMensuelCaHeures} */}
                  </StyledTableCell>
                  <StyledTableCell>{/* {sumMensuelCaActes} */}</StyledTableCell>
                  <StyledTableCell>
                    {/* {parseFloat(String(sumMensuelTarifHeures))?.toFixed(2)} */}
                  </StyledTableCell>
                  <StyledTableCell>
                    {/* {parseFloat(String(sumMensuelTarifActes))?.toFixed(2)} */}
                  </StyledTableCell>
                  <StyledTableCell>
                    {parseFloat(String(sumMensuelChiffreAffaire))?.toFixed(2)}
                  </StyledTableCell>

                  <StyledTableCell />

                  <StyledTableCell>
                    {/* {sumMensuelCoutHeures} */}
                  </StyledTableCell>
                  <StyledTableCell>
                    {/* {parseFloat(String(sumMensuelCoutParHeures))?.toFixed(2)} */}
                  </StyledTableCell>
                  <StyledTableCell>
                    {parseFloat(String(sumMensuelCout))?.toFixed(2)}
                  </StyledTableCell>
                  <StyledTableCell />
                  <StyledTableCell />
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="center" mt={5}>
            <LoadingButton
              onClick={() => handleSave()}
              endIcon={<SaveIcon />}
              loading={isClickSave}
              loadingPosition="end"
              sx={{ textTransform: "none" }}
              variant="contained"
              color="warning"
            >
              Enregistrer
            </LoadingButton>
          </Box>
        </>
      )}

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </Fragment>
  );
};

export default AddSaisieAgentForm;
